import React, { MouseEvent } from 'react';
import { renderers } from 'ui-library';
import { getClassNames } from 'utils';
import './CellLink.css';

// Assuming the ui-library provides these types,
// otherwise we define the shape for the renderer call.
const { CellLinked } = renderers;

interface CellLinkProps {
    label?: string;
    link?: string;
    /** Navigation state passed to the link */
    state?: Record<string, any>;
    disabled?: boolean;
}

export default function CellLink({
    label = '',
    link = '',
    state = {},
    disabled = false,
}: CellLinkProps) {
    const className = getClassNames('table-cell_checkboxed', {
        'table-cell_disabled': disabled,
        'table-cell_active': !disabled,
    });

    const handleStopPropagation = (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    return (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
        <div onClick={handleStopPropagation} className={className}>
            {CellLinked({
                value: label,
                link: {
                    pathname: link,
                    state,
                },
            })}
        </div>
    );
}
